import { useEffect } from "react";

export function useConsoleMessage() {
  useEffect(() => {
    console.log(
      "%cHey there!",
      "font-size: 3em; font-weight: bold; color: red",
    );
    console.log(
      "%cPlease don't use our console to find answers to JavaScript questions :)",
      "font-size: 2em; font-weight: bold",
    );
  }, []);
}
